import isNumber from 'lodash/isNumber'
import { Column } from '../models/column'

const shiftColumn = (columns: Column[], field, position) => {
  let columnIndex: number
  const res = []
  for (let i = 0; i < columns.length; i++) {
    const column = { ...columns[i] }
    res.push(column)
    if (isNumber(columnIndex)) {
      continue
    }
    if (column.field === field) {
      columnIndex = i
      continue
    }
    if (column.columns?.length) {
      column.columns = shiftColumn([...column.columns], field, position)
    }
  }
  if (isNumber(columnIndex) && columnIndex !== position) {
    res.splice(position, 0, res.splice(columnIndex, 1)[0])
    return res
  } else {
    return res
  }
}

export default shiftColumn
